// Fixed menu items
export const MENU_ITEMS = {
  "burger": { name: "Burger", price: 8.99, options: ["cheese", "bacon", "lettuce", "tomato", "onion"] },
  "fries": { name: "French Fries", price: 3.99, options: ["salt", "ketchup", "mayo", "ranch"] },
  "chicken": { name: "Chicken Sandwich", price: 9.99, options: ["grilled", "fried", "spicy", "mild"] },
  "salad": { name: "Caesar Salad", price: 7.99, options: ["dressing", "croutons", "cheese", "bacon"] },
  "drink": { name: "Soft Drink", price: 2.99, options: ["coke", "pepsi", "sprite", "diet", "water"] },
  "ice cream": { name: "Ice Cream", price: 4.99, options: ["vanilla", "chocolate", "strawberry", "mint"] },
  "shake": { name: "Milkshake", price: 5.99, options: ["vanilla", "chocolate", "strawberry", "oreo"] },
  "nuggets": { name: "Chicken Nuggets", price: 6.99, options: ["6 piece", "10 piece", "20 piece", "sauce"] },
  "wrap": { name: "Chicken Wrap", price: 8.99, options: ["grilled", "fried", "veggies", "sauce"] },
  "pizza": { name: "Pizza Slice", price: 4.99, options: ["pepperoni", "cheese", "veggie", "meat lovers"] }
};

export const languages = [
  { code: 'en-US', name: 'English (US)' },
  { code: 'en-GB', name: 'English (UK)' },
  { code: 'en-AU', name: 'English (Australia)' },
  { code: 'en-CA', name: 'English (Canada)' },
  { code: 'en-IN', name: 'English (India)' },
  { code: 'es-ES', name: 'Spanish (Spain)' },
  { code: 'es-MX', name: 'Spanish (Mexico)' },
  { code: 'fr-FR', name: 'French (France)' },
  { code: 'de-DE', name: 'German (Germany)' },
  { code: 'it-IT', name: 'Italian (Italy)' },
  { code: 'pt-BR', name: 'Portuguese (Brazil)' },
  { code: 'ja-JP', name: 'Japanese (Japan)' },
  { code: 'ko-KR', name: 'Korean (Korea)' },
  { code: 'zh-CN', name: 'Chinese (Simplified)' },
  { code: 'zh-TW', name: 'Chinese (Traditional)' },
  { code: 'ru-RU', name: 'Russian (Russia)' },
  { code: 'hi-IN', name: 'Hindi (India)' },
  { code: 'ar-SA', name: 'Arabic (Saudi Arabia)' },
];

export const API_BASE_URL = "https://litellm.rillavoice.com";
export const API_KEY = "sk-rilla-vibes"; 